import Vue from 'vue';
import Component from 'vue-class-component';
import * as ctpfront_pb from '@/../static/js/proto/CtpFront_pb';
import front from '@/../static/js/proto/CtpFront';
import * as ConditionData from '../../ConditionData';
// tslint:disable-next-line:max-line-length
import TargetKeyboard from '@/views/components/TargetKeyboard/TargetKeyboard.vue';
import * as utils from '@/utils/utils';
import { Prop, Watch } from 'vue-property-decorator';
/**
 * 新增条件单
 */
@Component({
  components: {
    TargetKeyboard,
  },
})
export default class ConditionInsert extends Vue {
  @Prop()
  public targentId;
  @Prop()
  public type;
  @Prop()
  public closeOut;
  @Prop()
  public money;
  public newPrice: any = '';
  public latestPrice: string = '--';
  public oldTargetId: string = '';

  // 最小变动价
  public smallPrice: any = '';

  // 颜色变化
  public f_red = false;
  public f_green = false;
  public f_grey = true;

  public showTargetKeyboard = false;
  public showPriceKeyboard = false;
  public showVolumeKeyboard = false;
  public showOrderPriceKeyboard = false;
  public showFeedbackToast = false;
  public feedbackMessage = '';
  public feedbackType = 'success';
  // 价格类型值
  public boardPrice: any = '';
  public triggerPriceType = front.con_last_price;
  public hasDraftInitialized = false;
  public lastInitializedRouteKey = '';
  public feedbackToastTimer = null;

  public triggerPriceTypeOptions = [
    {
      text: '最新价',
      value: front.con_last_price,
    },
  ];

  public triggerOperationOptions = [
    {
      text: '>=',
      value: front.con_operation_ge,
    },
    {
      text: '<=',
      value: front.con_operation_le,
    },
    {
      text: '>',
      value: front.con_operation_gt,
    },
    {
      text: '<',
      value: front.con_operation_lt,
    },
  ];

  public directionOptions = [
    {
      text: '买',
      value: front.direct_buy,
    },
    {
      text: '卖',
      value: front.direct_sell,
    },
  ];

  public offsetOptions = [
    {
      text: '开',
      value: front.offset_open,
    },
    {
      text: '平',
      value: front.offset_close,
    },
  ];

  public orderPriceTypeOptions = [
    {
      text: '对手价',
      value: front.con_opponent_price,
    },
    {
      text: '最新价',
      value: front.con_last_price,
    },
    {
      text: '市价',
      value: front.con_market_price,
    },
    {
      text: '超一价',
      value: front.con_plusone_tick_price,
    },
    {
      text: '限价',
      value: front.con_limit_price,
    },
  ];

  public validTimeOptions = [
    {
      text: '当日有效 (GFD)',
      value: front.con_validity_gfd,
    },
    {
      text: '永久有效 (GTC)',
      value: front.con_validity_all,
    },
  ];

  public formData = {
    operationType: front.con_operation_lt,
    price: '',
    offset: front.offset_open,
    direction: front.direct_buy,
    targetId: '',
    volume: 1,
    validTime: front.con_validity_gfd,
    orderPrice: '',
    orderPriceType: front.con_limit_price,
  };

  public get orderPrice() {
    if (this.formData.orderPriceType === front.con_limit_price) {
      return this.formData.orderPrice;
    }
    return ConditionData.getText(
      ConditionData.con,
      this.formData.orderPriceType);
  }

  public priceValue = '';

  public checkedOperationNum = -1;

  public get isBuy() {
    return this.formData.direction === front.direct_buy;
  }

  public get isLimitPrice() {
    return this.formData.orderPriceType === front.con_limit_price;
  }

  public get themeClass() {
    return this.isBuy ? 'theme-buy' : 'theme-sell';
  }

  public get triggerPriceTypeText() {
    return ConditionData.getText(this.triggerPriceTypeOptions,
      this.triggerPriceType) || '最新价';
  }

  public get operationTypeText() {
    return ConditionData.getText(this.triggerOperationOptions,
      this.formData.operationType) || '>=';
  }

  public get orderPriceTypeText() {
    return ConditionData.getText(this.orderPriceTypeOptions,
      this.formData.orderPriceType) || '对手价';
  }

  public get validTimeText() {
    return ConditionData.getText(this.validTimeOptions,
      this.formData.validTime) || '当日有效';
  }

  public get submitText() {
    return `提交云条件${this.isBuy ? '买' : '卖'}单`;
  }

  public get stepUnit() {
    const value = Number(this.smallPrice);
    return value > 0 ? value : 1;
  }

  public get stepPrecision() {
    const stepText = String(this.stepUnit);
    const index = stepText.indexOf('.');
    return index > -1 ? stepText.length - index - 1 : 0;
  }

  public get triggerPriceDisplay() {
    return this.formData.price ? this.formData.price : '--';
  }

  public get limitPriceDisplay() {
    return this.formData.orderPrice ? this.formData.orderPrice : '--';
  }

  public get volumeDisplay() {
    return this.formData.volume ? this.formData.volume : 1;
  }

  public get latestPriceDirectionClass() {
    if (this.f_red) {
      return 'latest-up';
    }
    if (this.f_green) {
      return 'latest-down';
    }
    return 'latest-flat';
  }

  @Watch('newPrice', { deep: true })
  public latestPrices(tick, old) {
    if (tick.latestPrice === tick.lastSettlementPrice) {
      this.f_red = false;
      this.f_green = false;
      this.f_grey = true;
    } else if (tick.latestPrice > tick.lastSettlementPrice) {
      this.f_red = true;
      this.f_green = false;
      this.f_grey = false;
    } else if (tick.latestPrice < tick.lastSettlementPrice) {
      this.f_red = false;
      this.f_green = true;
      this.f_grey = false;
    }
    this.$store.commit('priceTick/changePriceT', tick.priceTick);
    this.latestPrice = tick.latestPrice;
    this.smallPrice = Number((tick.priceTick * 10000).toFixed(0)) / 10000;
    this.syncDefaultPrices();
    this.changeBoardPrice();
  }
  @Watch('formData.orderPriceType', { deep: true })
  public changePriceType(news, old) {
    this.changeBoardPrice();
  }
  @Watch('formData.direction', { deep: true })
  public changeDirection(news, old) {
    this.changeBoardPrice();
  }
  public changeBoardPrice() {
    // console.log(this.formData.orderPriceType);
    this.boardPrice = 0;
    if (!this.newPrice) {
      return;
    }
    if (this.formData.direction === 1) {
      switch (this.formData.orderPriceType) {
        case 16:           // 对手价
          this.boardPrice =
            this.newPrice.askPrice1 ? this.newPrice.askPrice1 : 0;
          break;
        case 4:            // 最新价
          this.boardPrice =
            this.newPrice.latestPrice ? this.newPrice.latestPrice : 0;
          break;
        case 17:           // 市价
          this.boardPrice =
            this.newPrice.highStopPrice ? this.newPrice.highStopPrice : 0;
          break;
        case 18:           // 超价
          this.boardPrice =
            this.newPrice.bidPrice1 ? this.newPrice.bidPrice1 : 0;
          break;
      }
    } else if (this.formData.direction === 2) {
      switch (this.formData.orderPriceType) {
        case 16:           // 对手价
          this.boardPrice =
            this.newPrice.bidPrice1 ? this.newPrice.bidPrice1 : 0;
          break;
        case 4:            // 最新价
          this.boardPrice =
            this.newPrice.latestPrice ? this.newPrice.latestPrice : 0;
          break;
        case 17:           // 市价
          this.boardPrice =
            this.newPrice.lowStopPrice ? this.newPrice.lowStopPrice : 0;
          break;
        case 18:           // 超价
          this.boardPrice =
            this.newPrice.askPrice1 ? this.newPrice.askPrice1 : 0;
          break;
      }
    }
  }

  public mounted() {
    this.setDefault();
  }
  public deactivated() {
    this.newPrice = '';
    const currentTargetId = this.formData.targetId || this.oldTargetId || this.targentId;
    if (currentTargetId) {
      front.unsubTick(currentTargetId, 'conditionInsert');
    }
  }
  public activated() {
    const routeKey = this.getRouteDraftKey();
    if (!this.hasDraftInitialized || this.lastInitializedRouteKey !== routeKey) {
      this.setDefault();
      this.initDraftFromRoute();
      this.hasDraftInitialized = true;
      this.lastInitializedRouteKey = routeKey;
    }
    this.getLatestPrice();
  }
  public setDefault() {
    this.formData = {
      operationType: front.con_operation_lt,
      price: '',
      offset: front.offset_open,
      direction: front.direct_buy,
      targetId: '',
      volume: 1,
      validTime: front.con_validity_gfd,
      orderPrice: '',
      orderPriceType: front.con_opponent_price,
    };
    this.latestPrice = '--';
    this.boardPrice = 0;
    this.oldTargetId = '';
  }

  public initDraftFromRoute() {
    this.formData.targetId = this.targentId || this.formData.targetId;
    if (this.type === '买') {
      this.formData.direction = 2;
    } else if (this.type === '卖') {
      this.formData.direction = 1;
    }
    if (this.$route.query.Num) {
      this.formData.offset = 2;
    } else {
      this.formData.offset = 1;
    }
    this.formData.volume = this.closeOut || this.formData.volume || 1;
  }

  public getRouteDraftKey() {
    return [
      this.targentId || '',
      this.type || '',
      this.closeOut || '',
      this.money || '',
      this.$route.query.Num || '',
    ].join('|');
  }

  public selectTriggerOperation(value) {
    this.formData.operationType = value;
  }

  public cycleTriggerOperation() {
    const currentIndex = this.triggerOperationOptions.findIndex(
      item => item.value === this.formData.operationType);
    const nextIndex = currentIndex > -1
      ? (currentIndex + 1) % this.triggerOperationOptions.length
      : 0;
    this.formData.operationType = this.triggerOperationOptions[nextIndex].value;
  }

  public selectDirection(value) {
    this.formData.direction = value;
  }

  public selectOffset(value) {
    this.formData.offset = value;
  }

  public selectValidity(value) {
    this.formData.validTime = value;
  }

  public selectOrderPriceType(value) {
    this.formData.orderPriceType = value;
    if (value === front.con_limit_price && utils.isZero(this.formData.orderPrice)) {
      const fallback = this.parseNumeric(this.latestPrice) || this.boardPrice;
      if (fallback) {
        this.formData.orderPrice = this.formatStepValue(fallback);
      }
    }
  }

  public syncDefaultPrices() {
    const latest = this.parseNumeric(this.latestPrice);
    if (!latest) {
      return;
    }
    if (utils.isZero(this.formData.price)) {
      this.formData.price = this.formatStepValue(latest);
    }
    if (this.formData.orderPriceType === front.con_limit_price
      && utils.isZero(this.formData.orderPrice)) {
      this.formData.orderPrice = this.formatStepValue(latest);
    }
  }

  public parseNumeric(value) {
    const ret = Number(value);
    if (isNaN(ret)) {
      return 0;
    }
    return ret;
  }

  public formatStepValue(value) {
    return Number(value.toFixed(this.stepPrecision));
  }

  public getBaseValue(value, fallback = 0) {
    const current = this.parseNumeric(value);
    if (current) {
      return current;
    }
    return this.parseNumeric(fallback);
  }

  public adjustTriggerPrice(delta) {
    const base = this.getBaseValue(this.formData.price, this.latestPrice);
    const next = Math.max(0, base + delta * this.stepUnit);
    this.formData.price = this.formatStepValue(next);
  }

  public adjustOrderPrice(delta) {
    if (!this.isLimitPrice) {
      return;
    }
    const base = this.getBaseValue(this.formData.orderPrice, this.boardPrice || this.latestPrice);
    const next = Math.max(0, base + delta * this.stepUnit);
    this.formData.orderPrice = this.formatStepValue(next);
  }

  public adjustVolume(delta) {
    const next = Math.max(1, parseInt(this.formData.volume, 10) + delta || 1);
    this.formData.volume = next;
  }

  public openOrderPriceKeyboard() {
    if (!this.isLimitPrice) {
      return;
    }
    if (utils.isZero(this.formData.orderPrice)) {
      const fallback = this.parseNumeric(this.latestPrice) || this.boardPrice;
      if (fallback) {
        this.formData.orderPrice = this.formatStepValue(fallback);
      }
    }
    this.showOrderPriceKeyboard = true;
  }

  public openFeedbackToast(message: string, type = 'success', duration = 2000) {
    this.feedbackMessage = message;
    this.feedbackType = type;
    this.showFeedbackToast = true;
    if (this.feedbackToastTimer) {
      clearTimeout(this.feedbackToastTimer);
    }
    this.feedbackToastTimer = setTimeout(() => {
      this.showFeedbackToast = false;
      this.feedbackToastTimer = null;
    }, duration);
  }

  // 增加条件单
  public addCondition() {
    const cond = new ctpfront_pb.OrderConditional();
    const data = this.formData;

    if (!this.formData.targetId) {
      this.openFeedbackToast('请选择合约', 'error');
      return;
    }
    if (!this.formData.price) {
      this.openFeedbackToast('请输入价格', 'error');
      return;
    }
    if (!this.formData.volume) {
      this.openFeedbackToast('请输入手数', 'error');
      return;
    }
    if (this.formData.orderPriceType === front.con_limit_price
      && utils.isZero(this.formData.orderPrice)) {
      this.openFeedbackToast('请输入报单价', 'error');
      return;
    }
    if (this.formData.orderPriceType === 2 &&
      ((Number(this.formData.orderPrice) * 1000000) as any).toFixed(0) %
      ((this.smallPrice * 1000000) as any).toFixed(0) !== 0) {
      this.openFeedbackToast('下单价格不符合该合约的最小变动价位', 'error');
      return;
    }
    if (((Number(this.formData.price) * 1000000) as any).toFixed(0) %
    ((this.smallPrice * 1000000) as any).toFixed(0) !== 0) {
      this.openFeedbackToast('下单价格不符合该合约的最小变动价位', 'error');
      return;
    }
    cond.setTargetId(data.targetId);
    cond.setPrice(data.price);
    cond.setConditionPriceType(this.triggerPriceType);
    cond.setOperationType(data.operationType);
    cond.setVolume(data.volume);
    cond.setDirection(data.direction);
    cond.setOffset(data.offset);
    cond.setValidTime(data.validTime);
    cond.setState(0);
    cond.setOrderPrice(data.orderPrice);
    cond.setOrderPriceType(data.orderPriceType);
    // cond.setStateDetail("状态详情");
    // cond.setAccount("xuefeng");
    utils.indicator('正在处理...');
    front.conditionOrderSave(cond, resolve => {
      utils.closeIndicator();
      this.openFeedbackToast('添加云条件单成功', 'success', 2200);
      // this.setDefault();
      console.log(resolve);
    }, reject => {
      console.error(reject);
      utils.closeIndicator();
      this.openFeedbackToast('添加云条件单失败: ' + reject.message, 'error', 2600);
    });

  }
  public handleCancel() {
    this.setDefault();
    this.hasDraftInitialized = true;
  }

  public beforeDestroy() {
    if (this.feedbackToastTimer) {
      clearTimeout(this.feedbackToastTimer);
      this.feedbackToastTimer = null;
    }
  }

  // 键盘选择合约时触发事件
  public choiceTargetId(targetId) {
    if (this.oldTargetId) {
      front.unsubTick(this.oldTargetId, 'conditionInsert');
      this.latestPrice = '--';
    }
    this.setDefault();
    this.formData.targetId = targetId;
    this.oldTargetId = targetId;
    this.newPrice = front.subTick(targetId, 'conditionInsert');
  }

  // 最新价
  public getLatestPrice() {
    const currentTargetId = this.formData.targetId || this.targentId;
    if (currentTargetId) {
      this.oldTargetId = currentTargetId;
      this.newPrice = front.subTick(currentTargetId, 'conditionInsert');
    } else {
      this.latestPrice = '--';
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/condition/components/ConditionInsert/ConditionInsert.ts